import { Hero } from '../../components/landing/Hero';
import { Expertise } from '../../components/landing/Expertise';
import { WhyChooseUs } from '../../components/landing/WhyChooseUs';
import { Partners } from '../../components/landing/Partners';
import { AdBanner } from '../../components/ads/AdBanner';

export function HomePage() {
  return (
    <main>
      <Hero />
      
      {/* Test Ad Banner - GAM */}
      <section className="py-8 bg-gray-50">
        <div className="container mx-auto px-4 flex justify-center">
          <AdBanner slotId="div-gpt-ad-1776941487046-0" />
        </div>
      </section>
      
      <Expertise />
      <WhyChooseUs />
      <Partners />
    </main>
  );
}